module.exports = "<form action=\"#\" method=\"get\" class=\"sidebar-form\">\n</form>\n"